export const BADGE_TYPE_CHOICES = [
  { id: 'quiz_master', name: 'Kvízmester' },
  { id: 'keen_reader', name: 'Lelkes olvasó' },
  { id: 'treasure_hunter', name: 'Kincsvadász' },
  { id: 'lucky', name: 'Szerencsés' },
];

export const BADGE_TIER_CHOICES = [
  { id: 'bronze', name: 'Bronze' },
  { id: 'silver', name: 'Silver' },
  { id: 'gold', name: 'Gold' },
];

export const DATE_INPUT_FORMAT = 'YYYY.MM.DD';
export const DATE_TIME_FIELD_FORMAT = 'YYYY.MM.DD HH:mm';
